export const MILLISECONDS_IN_WEEK = 604800000;
export const MILLISECONDS_IN_DAY = 86400000;
export const MILLISECONDS_IN_HOUR = 3600000;
export const MILLISECONDS_IN_MINUTE = 60000;
export const MILLISECONDS_IN_SECOND = 1000;
export const MONTHS_IN_YEAR = 12;
export const SECONDS_PER_MINUTE = 60;

export const MIN_JAVASCRIPT_TIMESTAMP = -8640000000000000;
export const MAX_JAVASCRIPT_TIMESTAMP = 8640000000000000;

export const MIN_OUTLOOK_TIMESTAMP = Date.UTC(1601, 0, 1);
export const MAX_OUTLOOK_TIMESTAMP = Date.UTC(4501, 0, 1);
